import './faq.css'
import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

function Faq() {
    const DeatelisSection = [
        {
          id: 1,
          title: "أين يقع مركز دكتور كار لصيانة السيارات ؟",
          des: "يقع في منطقة القصيم بمدينة بريدة حي المنتزة",
        },
        {
          id: 2,
          title: "متى يفتح المركز ؟ ساعات العمل ؟",
          des: "كل يوم من ٨ صباحاً - ١١ مساءً",

        },
        {
          id: 3,
          title: "ماذا يعني مكانيكا السيارات ؟",
          des: "مكانيكا السيارات هي مجال صيانة وإصلاح الأجزاء الميكانيكية والكهربائية في السيارات. يتضمن هذا المجال مجموعة واسعة من الأعمال التي تتعلق بعمل المحركات، أنظمة التبريد والتدفئة، أنظمة العادم، أنظمة الوقود، الفرامل، وأنظمة التعليق وغيرها.",

        },
        {
          id: 4, // تعديل الرقم المتكرر هنا من 3 إلى 4
          title: "ماهي الخدمات التي يقدمها المركز ؟",
          des: "تركيب مكائن جديدة ومستوردة - بيع مكائن - توضيب مكائن - ترهيم مكائن - تركيب قير - توضيب قير - كل ما يخص مكانيكا السيارات",

        },
        {
          id: 5,
          title: "ماهي أنواع مكائن السيارات لديكم ؟",
          des: "مكينة هايلوكس - مكينة جيب لكزس - مكينة ددسن بخاخ - مكينة يارس - مكينة صني - مكينة ربع - مكينة كورلا - مكينة اكسنت - مكينة سوناتا - مكينة كامري - بالإضافة إلى توفير أي نوع ماكينة يحتاجها العميل ",
        },
        {
            id: 6,
            title: "هل يوجد لديكم ضمان على المكائن التي يتم تركيبها أو بيعها ؟",
            des: "نعم يوجد ضمان",
          },
          {
            id: 7,
            title: "ماذا يعني توضيب ماكينة السيارة ؟",
            des: "توضيب ماكينة السيارة (المعروف أيضًا بـ -إعادة بناء المحرك -أو  - توضيب المحرك - ) هو عملية إصلاح شاملة لمحرك السيارة بغرض إعادة تأهيله ليعمل بكفاءة كما لو كان جديدًا. يشمل التوضيب عادة تفكيك المحرك بالكامل، وفحص جميع الأجزاء، واستبدال أو إصلاح الأجزاء التالفة أو المهترئة.",
          },
          {
            id: 8,
            title: "أيهما أفضل توضيب المكينة أو تركيب مكينة جديدة ؟",
            des: "الاختيار بين توضيب المكينة أو تركيب مكينة جديدة يعتمد على عدة عوامل تشمل الحالة الحالية للمحرك، التكلفة، الأمان، وطول المدة الزمنية التي تنوي الاحتفاظ فيها بالسيارة."
          },
      ];
  return (
    <div className='faq' id='faqid'>
        <div className="container">
        <div class="section-title text-center mb-3">
                        <h5 class="sub-titleall">الأسئلة الشائعة</h5>
                        <h2 class="titleall">أسئلة العملاء المتكررة</h2>
        </div>
        <div>
        <div className="row">
        {DeatelisSection.map((item, index) => (
            <div className="col-12" key={index}>
            <Accordion className='box-faq'>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
             {item.title}
        </AccordionSummary>
        <AccordionDetails className='desfaq'>
            {item.des}
                </AccordionDetails>
            </Accordion>
                </div>
                ))}
        </div>
    </div>
        </div>
    </div>
  )
}

export default Faq